import React from 'react';
import styled from 'styled-components';

import device from '../../utils/device';

const Container = styled.div`
  display: grid;
  width: 4.8rem;

  > * {
    grid-row: 1;
    grid-column: 1;
  }

  div {
    font-family: 'Montserrat';
    font-weight: 900;
    font-size: 0.58rem;
    text-transform: uppercase;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${device.desktop} {
    width: 6rem;

    div {
      font-size: .75rem;
    }
  }

  @media ${device.bigDesktop} {
    width: 8rem;

    div {
      font-size: 1rem;
    }
  }
`;

const VideoButton = ({ color, text }) => (
  <Container>
    <svg viewBox="0 0 96.15 36.7">
      <g stoke={color} fill={color}>
        <path
          d="M78.55,0
          H17.6
          a17.6,17.6,0,0,0,0,35.2
          H56.23
          l0 -1.6
          H17.6
          a16,16,0,0,1,0-32
          h61
          a16,16,0,0,1,0,32
          H69.11
          V32.06
          l-2.32,2.32,2.32,2.32
          V35.2
          h9.44
          a17.6,17.6,0,1,0,0-35.2
          Z"
        />
      </g>
    </svg>
    <div>
      <span style={{ color }}>{text}</span>
    </div>
  </Container>
);

export default VideoButton;
